import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../../maps/data.js";
import Icn from "../../components/Icn.js";
import Tx from "../../components/Tx.js";
import PageTitle from "../../components/PageTitle.js";
import styled from "styled-components";
import Stats from "../../components/Stats.js";
import Lot from "../../components/Lot.js";
import Card from "@mui/material/Card";
import { dateAgo } from "../../utils.js";
import { colors } from "../../maps/colors.js";
import ProductInCartRow from "../../components/cart/ProductInCartRow.js";
import useZibi from "../../zibi/UseZibi.js";
import ProductChooseDialog from "../../components/dialogs/ProductChooseDialog.js";
import VideoPlayer from "../../components/camera/VideoPlayer.js";
import { register, unregister } from "../../domain/socketSlice.js";
import { getQueryValue } from "../../domain/queryHandler.js";
import ALERT_MAP from "../../maps/alertMap.js";

const WrapperStyled = styled.div`
  background: rgb(248, 249, 250);
  padding: 20px;
  position: relative;
`;

const ImagePreview = styled.div`
  position: absolute;
  width: 60%;
  top: 200px;
  right: 50px;

  img {
    width: 100%;
  }
`;

const AccountImageWrapperStyled = styled.div`
  .profile-image {
    width: 100%;
  }

  .no-name-box {
    font-size: 32px;
    color: ${colors.WHITE};
    background-color: #bdbdbd;
    height: 100%;
    text-align: center;
    align-content: center;
    display: grid;
  }

  img {
    height: 200px;
    width: 100%;
    object-fit: cover;
  }
`;

const AlertStyled = styled.div`
  position: relative;

  h3 {
    margin: 0 0 10px 0;
  }
`;

const SectionStyled = styled.div`
  margin-top: 10px;
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-gap: 10px;
`;

const InfoAndActionsStyled = styled.div`
  display: grid;
  position: absolute;
  grid-gap: 11px;
  text-align: center;
  justify-self: center;
  top: 100px;
`;

const InfoStyled = styled.div`
  font-size: 13px;
`;

const CameraStyled = styled.div`
  h5 {
    margin: 0;
  }

  img {
    width: 100%;
  }
`;

const CameraWrapperStyled = styled.div`
  display: grid;
  grid-template-columns: 3fr 3fr 1fr;
  grid-gap: 13px;
`;

const CameraItemsStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 13px;
  position: relative;

  img {
    max-width: 200px;
  }
`;

const IndependedActionsStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-items: center;
`;

const ProductsStyled = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  gap: 13px;
`;

const VideoWrapperStyled = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  position: relative;

  img {
    padding: 0 30px;
    width: 100%;
  }
`;

const OkActionStyled = styled.div`
  background: #05ea05;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: grid;
  justify-content: center;
  align-content: center;
  box-shadow: rgba(0, 0, 0, 0.05) 0 1.25rem 1.6875rem 0;
  border: 1px solid #000;
  cursor: pointer;
`;

const EditActionStyled = styled.div`
  background: ${colors.CYAN};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: grid;
  justify-content: center;
  align-content: center;
  box-shadow: rgba(0, 0, 0, 0.05) 0 1.25rem 1.6875rem 0;
  border: 1px solid #000;
  cursor: pointer;
`;

const DunnoActionStyled = styled.div`
  background: ${colors.RED1};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: grid;
  justify-content: center;
  align-content: center;
  box-shadow: rgba(0, 0, 0, 0.05) 0 1.25rem 1.6875rem 0;
  border: 1px solid #000;
  cursor: pointer;
`;

const GroundTruthStyled = styled.span`
  position: absolute;
  height: 4px;
  width: 100%;
  background: #85c775;
  z-index: 2;
  top: 0;
  left: 0;
  right: 0;

  &.val-2 {
    background: red;
  }
`;

const ShopperCartStyled = styled.div`
  margin-top: 15px;
  height: 400px;
  overflow-y: auto;
`;

const ShopperCartProductStyled = styled.div`
  margin-bottom: 10px;
`;

const LabelStyled = styled.span`
  color: rgb(103, 116, 142);
  font-size: 12px;
`;

const LottieAlertStyled = styled.div`
  width: 400px;
  margin: 20px auto;
  text-align: center;

  span {
    font-size: 22px;
  }
`;

const InfoCartItemStyled = styled.div``;

const InfoCartSeparatorItemStyled = styled.div`
  display: grid;
  margin-bottom: 5px;

  & > div {
  }
`;

const DebugPage = () => {
  const location = useLocation();
  const sev = getQueryValue(location, "sev");
  const alertId = getQueryValue(location, "alertId");

  const [productsByBarCode, set_productsByBarCode] =
    useZibi("productsByBarCode");
  const [productsById, set_productsById] = useZibi("productsById");
  const [cameras, set_cameras] = useZibi("cameras");

  const [data, s_data] = useState(null);
  const [sensors, s_sensors] = useState([]);
  const [cart, s_cart] = useState([]);
  const [editDialog, s_editDialog] = useState(false);
  const [hoverItemImage, s_hoverItemImage] = useState(null);

  const siteId = data?.alerts?.[0]?.siteId;
  const shopperId = data?.alerts?.[0]?.shopperId;
  const alert = data?.alerts?.[0];

  const eventName = "alerts-event";

  useEffect(() => {
    register(eventName);
    window.addEventListener(eventName, onAlerts);
    return () => {
      unregister(eventName);
      window.removeEventListener(eventName, onAlerts);
    };
  }, []);

  useEffect(() => {
    if (sev) {
      getSingleAlert();
    }
  }, [sev]);

  useEffect(() => {
    if (alertId) {
      getSingleAlert();
    }
  }, [alertId]);

  const onAlerts = async () => {
    if (!alert) {
      getSingleAlert();
    }
  };

  const getSingleAlert = async () => {
    const dataRes = await api({
      type: "getAlerts",
      data: { isSingle: true, severity: sev, alertId },
    });
    s_data(dataRes);
  };

  const getCamerasById = async (ids) => {
    const dataRes = await api({ type: "getCamerasByIds", data: { ids } });
    const tempCameras = { ...cameras };
    dataRes.forEach((cam) => {
      tempCameras[cam._id] = cam;
    });
    set_cameras(tempCameras);
  };

  const getSensors = async (sensorIds) => {
    const res = await api({
      type: "getSensors",
      data: { filterOutSensorIds: sensorIds },
    });
    s_sensors(res);
  };
  useEffect(() => {
    getSingleAlert();
  }, []);

  useEffect(() => {
    const sensorIds = alert?.field?.shelves?.map((pp) => pp.sensorId);
    if (sensorIds?.length) {
      getSensors(sensorIds);
    }
  }, [data]);

  useEffect(() => {
    if (alert?.data) {
      const cameraIds = alert?.data?.cameras?.map((c) => c.cameraId);
      const noCameraData = [];

      alert?.data?.cameras?.forEach((cam) => {
        if (!cameras[cam.cameraId]) {
          noCameraData.push(cam.cameraId);
        }
      });

      cameraIds.forEach((camId) => {
        if (!cameras[camId]) {
          noCameraData.push(camId);
        }
      });

      if (noCameraData?.length) {
        getCamerasById(noCameraData);
      }
    }
  }, [alert?.data]);

  useEffect(() => {
    if (!Object.keys(productsByBarCode).length) {
      api({
        type: "getProducts",
        data: { allProducts: true, ignoreCategory: true },
      }).then(({ products }) => {
        const temp = {};
        const tempIds = {};
        for (let i = 0; i < products.length; i++) {
          const product = products[i];
          temp[product.barcode] = product;
          tempIds[product._id] = product;
        }
        set_productsByBarCode(temp);
        set_productsById(tempIds);
      });
    }
  }, []);

  useEffect(() => {
    if (shopperId && siteId) {
      api({
        type: "getShopperCart",
        data: { siteId, shopperId, fullProductData: true },
      }).then((data) => {
        s_cart(data);
      });
    }
  }, [siteId, shopperId, alert]);

  let stats = [];
  if (data) {
    stats = [
      {
        label: "Active",
        value: data.active,
      },
      {
        label: "Pending",
        value: data.pending,
      },
      {
        label: "Handling",
        value: data.handling,
      },
    ];
  }

  const name = alert?.shopper?.name || "NA";
  const imageUrl = alert?.shopper?.imageUrl;
  const getName = () => {
    return `${name.charAt(0)}${name.charAt(name.length - 1)}`;
  };

  const camerasData = alert?.data?.cameras?.map((cam) => {
    let tempCam = cam;
    const cameraFromField = alert?.field?.cameras?.find(
      (tt) => tt._id === cam.cameraId
    );
    if (cameraFromField) {
      const camFromApi = cameras[cameraFromField._id];
      tempCam = { ...tempCam, ...cameraFromField, ...camFromApi };
    }
    return tempCam;
  });

  const handleActions = async (
    type,
    productId,
    name = "AI",
    actionNeeded = true
  ) => {
    if (type === "ok") {
      await api({
        type: "editAlert",
        data: {
          _id: alert._id,
          status: "HANDLED",
          solution: {
            name: name,
            productId: productId,
          },
          actionNeeded,
        },
      });
      await getSingleAlert();
    }
    if (type === "unknown") {
      await api({
        type: "editAlert",
        data: {
          _id: alert._id,
          status: "CLOSED",
        },
      });
      await getSingleAlert();
    }
    if (type === "edit") {
      s_editDialog(true);
    }
  };

  const onChooseProduct = async (product) => {
    s_editDialog(false);
    await api({
      type: "editAlert",
      data: {
        _id: alert._id,
        actionNeeded: true,
        status: "HANDLED",
        solution: {
          name: "Manual",
          productId: product._id,
        },
      },
    });
    await getSingleAlert();
  };

  const product = productsById[camerasData?.[0]?.productId];
  const solutionProduct = productsById[alert?.solution?.productId];

  const frontCams = camerasData?.filter((pp) => pp.cameraType === "FRONT");
  const topCams = camerasData?.filter((pp) => pp.cameraType !== "FRONT");

  return (
    <div style={{ height: "100%", overflowY: "scroll", padding: 20 }}>
      <PageTitle>
        <Icn>errorIcon</Icn> <Tx>page.alert.title</Tx>
      </PageTitle>
      <WrapperStyled>
        {data && <Stats items={stats} />}

        <h2>
          <Tx>page.alerts.alertToHandle</Tx> ({alert?.severity}){" "}
          {alert?.groundTruth ? "GroundTruth" : ""} Status: {alert?.status}
        </h2>

        {alert && (
          <AlertStyled>
            {alert.groundTruth && (
              <GroundTruthStyled className={`val-${alert.groundTruth}`} />
            )}
            <SectionStyled>
              <Card
                sx={{
                  boxShadow: "rgba(0, 0, 0, 0.05) 0rem 1.25rem 1.6875rem 0rem",
                  padding: "20px",
                }}
              >
                <CameraWrapperStyled>
                  <CameraItemsStyled>
                    {frontCams?.map((cam, idx) => {
                      if (!cam.imageUrl) {
                        return null;
                      }
                      return (
                        <CameraStyled key={idx}>
                          <h5>
                            {cam.cameraType} - {cam.name}
                          </h5>

                          <VideoWrapperStyled>
                            <VideoPlayer videoSource={cam.imageUrl} />
                          </VideoWrapperStyled>
                        </CameraStyled>
                      );
                    })}
                  </CameraItemsStyled>
                  <CameraItemsStyled>
                    {topCams?.map((cam, idx) => {
                      if (!cam.imageUrl) {
                        return null;
                      }
                      return (
                        <CameraStyled key={idx}>
                          <h5>
                            {cam.cameraType} - {cam.name}
                          </h5>

                          <VideoWrapperStyled>
                            <VideoPlayer videoSource={cam.imageUrl} />
                          </VideoWrapperStyled>
                        </CameraStyled>
                      );
                    })}
                  </CameraItemsStyled>
                  <CameraItemsStyled>
                    <ProductsStyled>
                      {!product && (
                        <IndependedActionsStyled>
                          <EditActionStyled
                            onClick={() => {
                              handleActions("edit");
                            }}
                          >
                            <Icn>edit</Icn>
                          </EditActionStyled>
                          <DunnoActionStyled
                            onClick={() => {
                              handleActions("unknown");
                            }}
                          >
                            <Icn>sentimentVeryDissatisfiedIcon</Icn>
                          </DunnoActionStyled>
                        </IndependedActionsStyled>
                      )}
                      {product?.imageUrl && (
                        <>
                          <InfoAndActionsStyled>
                            <OkActionStyled
                              onClick={() => {
                                handleActions("ok", product._id);
                              }}
                            >
                              <Icn>thumbUpIcon</Icn>
                            </OkActionStyled>
                            <EditActionStyled
                              onClick={() => {
                                handleActions("edit");
                              }}
                            >
                              <Icn>edit</Icn>
                            </EditActionStyled>
                            <DunnoActionStyled
                              onClick={() => {
                                handleActions("unknown");
                              }}
                            >
                              <Icn>sentimentVeryDissatisfiedIcon</Icn>
                            </DunnoActionStyled>
                          </InfoAndActionsStyled>
                          <img src={product.imageUrl} alt="product preview" />
                        </>
                      )}
                    </ProductsStyled>
                    <ProductsStyled>
                      {solutionProduct && (
                        <>
                          <InfoAndActionsStyled>
                            <OkActionStyled
                              onClick={() => {
                                handleActions(
                                  "ok",
                                  solutionProduct._id,
                                  "barcode",
                                  true
                                );
                              }}
                            >
                              <Icn>thumbUpIcon</Icn>
                            </OkActionStyled>
                          </InfoAndActionsStyled>
                          <img
                            src={solutionProduct.imageUrl}
                            alt="product preview"
                          />
                        </>
                      )}
                    </ProductsStyled>
                  </CameraItemsStyled>
                </CameraWrapperStyled>
              </Card>

              <div>
                <Card
                  sx={{
                    boxShadow:
                      "rgba(0, 0, 0, 0.05) 0rem 1.25rem 1.6875rem 0rem",
                    padding: "20px 20px 5px",
                  }}
                >
                  <InfoCartItemStyled>
                    <InfoCartSeparatorItemStyled
                      style={{ gridTemplateColumns: "1fr 3fr", gridGap: 10 }}
                    >
                      <div>
                        <AccountImageWrapperStyled>
                          <div className="profile-image">
                            {imageUrl && <img alt={name} src={imageUrl} />}

                            {name && !imageUrl && (
                              <div className="no-name-box">{getName()}</div>
                            )}
                          </div>
                        </AccountImageWrapperStyled>
                      </div>
                      <div>
                        <InfoStyled>
                          <LabelStyled>Name:</LabelStyled> {alert.shopper?.name}
                        </InfoStyled>
                        <InfoStyled>
                          <LabelStyled>Phone:</LabelStyled>{" "}
                          {alert.shopper?.phone}
                        </InfoStyled>
                        <InfoStyled>
                          <LabelStyled>Email:</LabelStyled>{" "}
                          {alert.shopper?.email}
                        </InfoStyled>
                      </div>
                    </InfoCartSeparatorItemStyled>
                    <InfoCartSeparatorItemStyled>
                      <InfoStyled>
                        <LabelStyled>Since:</LabelStyled>{" "}
                        {dateAgo(alert.createdAt)}
                      </InfoStyled>
                      <InfoStyled>
                        <LabelStyled>Site:</LabelStyled> {alert.site?.name}
                      </InfoStyled>
                      <InfoStyled>
                        <LabelStyled>Shopper:</LabelStyled>{" "}
                        {alert.shopper?.name}
                      </InfoStyled>
                      <InfoStyled>
                        <LabelStyled>Type:</LabelStyled>{" "}
                        <b>{ALERT_MAP.eventTypes[alert.eventSubType]?.title}</b>
                      </InfoStyled>
                    </InfoCartSeparatorItemStyled>
                  </InfoCartItemStyled>
                  <InfoCartItemStyled>
                    <h3>Shopper cart</h3>
                    <ShopperCartStyled>
                      {cart?.[0]?.products?.map((product, idx) => {
                        return (
                          <ShopperCartProductStyled key={product._id + idx}>
                            <ProductInCartRow product={product} />
                          </ShopperCartProductStyled>
                        );
                      })}
                    </ShopperCartStyled>
                  </InfoCartItemStyled>
                </Card>
              </div>
            </SectionStyled>
          </AlertStyled>
        )}

        {!alert && (
          <LottieAlertStyled>
            <span>Currently no alert to handle</span>
            <Lot>emptyAlert</Lot>
          </LottieAlertStyled>
        )}
      </WrapperStyled>

      {editDialog && (
        <ProductChooseDialog
          onClose={() => {
            s_editDialog(false);
          }}
          open={editDialog}
          onChooseProduct={onChooseProduct}
          products={Object.values(productsByBarCode)}
        />
      )}

      {hoverItemImage && (
        <ImagePreview>
          <img src={hoverItemImage} alt="preview" />
        </ImagePreview>
      )}
    </div>
  );
};

export default DebugPage;
